var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "100px",
    height: "100px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#8c00ff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.94336,1c-0.22878,0.01354 -0.44598,0.10524 -0.61523,0.25977l-10.87891,9.89063c-0.33602,0.22031 -0.50757,0.62033 -0.43555,1.01563c0.00559,0.03223 0.01276,0.06417 0.02148,0.0957c0.00064,0.00196 0.0013,0.00391 0.00195,0.00586c0.00414,0.01639 0.0087,0.03267 0.01367,0.04883l0.01563,0.04297l1.84961,5.55273l-10.74219,-1.89648c-0.51115,-0.09054 -1.0066,0.22505 -1.14062,0.72656l-3.95898,14.84961c-0.1894,0.43344 -0.04924,0.94029 0.33594,1.21484c0.01656,0.01224 0.0335,0.02396 0.05078,0.03516l25,16c0.0026,0.00131 0.0052,0.00262 0.00781,0.00391c0.46344,0.29853 1.08106,0.16574 1.38086,-0.29687l16.89648,-18.88281c0.31958,-0.35794 0.3399,-0.89241 0.04841,-1.27358c-0.29148,-0.38117 -0.81261,-0.5016 -1.24177,-0.28697l-8.90234,4.45117l-3.98437,-2.32617l9.74023,-6.30273c0.27623,-0.1203 0.48351,-0.35872 0.56423,-0.64899c0.08072,-0.29028 0.02627,-0.60147 -0.14821,-0.8471c-0.01183,-0.01731 -0.02421,-0.03425 -0.03711,-0.05078l-2.05078,-2.60156l3.98242,1.17969c0.30242,0.08926 0.62922,0.03067 0.8818,-0.15809c0.25258,-0.18876 0.40134,-0.48558 0.40141,-0.80089v-6c0.00014,-0.3151 -0.14823,-0.61183 -0.40039,-0.80078l-16,-12c-0.16123,-0.12099 -0.35526,-0.19043 -0.55664,-0.19922c-0.03318,-0.00165 -0.06643,-0.00165 -0.09961,0zM29.06055,3.29492l14.93945,11.20508v4.16016l-24.01367,-7.11523zM35.5,11c-0.82843,0 -1.5,0.67157 -1.5,1.5c0,0.82843 0.67157,1.5 1.5,1.5c0.82843,0 1.5,-0.67157 1.5,-1.5c0,-0.82843 -0.67157,-1.5 -1.5,-1.5zM19.55469,13.50391l17.85547,5.29102l2.18164,2.76563l-18.43555,-3.25391zM8.73047,18.14453l30.58984,5.39844l-14.57227,9.42773l-19.47656,-1.85547zM30.7832,31.44922l3.73047,2.17578l-4.96094,2.48047c-0.31003,0.155 -0.51769,0.45948 -0.54883,0.80469l-0.85156,9.36133l-20.12891,-12.88281l16.88086,1.60742c0.22442,0.02139 0.44948,-0.03367 0.63867,-0.15625zM41.76172,32.23633l-11.49219,12.8457l0.67578,-7.4375z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.8649187032039f2336383f15bc25294c.svg";
export { ForwardRef as ReactComponent };